'use client'
import Text from '@/components/custom-ui/text'
import { Dictionary } from '@/localization/dictionary'

interface EmptyStateProps {
  dict: Dictionary['shoppingBag']['emptyState']
}

const EmptyState = ({ dict }: EmptyStateProps) => {
  return (
    <div className="mb-13 mt-16 min-h-[50svh]">
      <Text as="h2" uppercase className="text-center">
        {dict.shoppingBag}
      </Text>
      <Text as="h6" uppercase className="mb-4 mt-9 text-center sm:mt-25">
        {dict.title}
      </Text>
      <Text as="p" className="text-center">
        {dict.subtitle}
      </Text>
    </div>
  )
}

export default EmptyState
